import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "onChange", "readOnly", "value"];
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const InputText = _ref => {
  let {
      disabled,
      onChange,
      readOnly,
      value
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const handleOnChange = event => {
    onChange(event.target.value);
  };
  return /*#__PURE__*/_jsx(TextInput, Object.assign({}, rest, spacingProps, {
    disabled: disabled,
    onChange: handleOnChange,
    readOnly: disabled || readOnly,
    value: value
  }));
};
const InputTextWrapper = props => /*#__PURE__*/_jsx(InputWrapper, Object.assign({}, props));
InputTextWrapper.displayName = 'InputWrapper';
InputText.Wrapper = InputTextWrapper;